import * as React from 'react';
import { ClientFilterV2 } from './ClientFilterV2';
import { StepFilter } from './StepFilter';
import { FlagFilter } from './FlagFilter';
import { StateFilter } from './StateFilter';
import { AddFilter } from './AddFilter';
import { ActiveFiltersPills } from './ActiveFiltersPills';
import { Icon } from '@/components/common';
import Icons from '@/const/icons';
import { useFilters } from '@/hooks';
import { TooltipComponent } from '@/components/common/tooltip';
import { DocFilter } from './DocFilter';

export const CaseClientFilters = () => {
	const { clearSpecificFilters, hasFilter } = useFilters();

	const FILTER_KEYS = [
		'search',
		'step',
		'messageFilter',
		'sort',
		'dateFrom',
		'dateTo',
		'documentFilter',
		'claimFormQuestions',
		'flagged',
		'flaggedReason',
		'documents',
		'state',
	];

	const handleClearAll = () => clearSpecificFilters(FILTER_KEYS);

	const showClearAll = FILTER_KEYS.some((key) => hasFilter(key));

	return (
		<div className="flex flex-wrap items-center gap-2 mb-4">
			<ClientFilterV2 />
			<StepFilter />
			<DocFilter />
			<FlagFilter />
			<StateFilter />
			<ActiveFiltersPills />
			<AddFilter />

			{showClearAll && (
				<TooltipComponent
					trigger={
						<button
							type="button"
							onClick={handleClearAll}
							className="transition-colors rounded-lg p-2 hover:bg-grey-5"
						>
							<Icon
								src={Icons.close}
								width={16}
								height={16}
								className="text-opacity-black"
							/>
						</button>
					}
					label="Clear all filters"
					classNameLabel="font-semibold"
				></TooltipComponent>
			)}
		</div>
	);
};
